import React, { useEffect} from "react";
import { useFormik } from "formik";
import * as Yup from "yup"
export default function AddAdminTransporter({onAdd,onEdit,transporterToEdit,setTransporterToEdit}){
    const formik=useFormik({
      initialValues:{
      name: "",
      email: "",
      location: "",
      image_url:""      
      },
      validationSchema:Yup.object({
        name: Yup.string().required('Name is required').typeError("Plaese enter a string"),
        email: Yup.string().email('Invalid email format').required('Email is required').typeError("Please enter an email"),
        location: Yup.string().required('Location is required').typeError("Please enter a location"),
        image_url:Yup.string().url("Invalid url format").required("Image url is required").typeError("Image url should be a string")
      }),
    onSubmit:(values,{setSubmitting})=>{
       try {
        if (transporterToEdit){
          onEdit(values) 
          setTransporterToEdit(null)    
          formik.resetForm()     
        }
        else{
          onAdd(values)
          setTransporterToEdit(null)
          formik.resetForm()
        }        
       } catch (error) {
         console.error("An error occurrred adding or deleting transporter",error)
       }
      finally{
        setSubmitting(false)
      }
      }
    })

    useEffect(()=>{
       if (transporterToEdit){
        formik.setValues(transporterToEdit)
       }
    },[transporterToEdit])
  
    return(
      <div>
         <form onSubmit={formik.handleSubmit} className=" space-y-4">
        <label htmlFor="name">Name</label>
        <input
          type="text"
          id="name"
          name="name"
          value={formik.values.name}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          placeholder="Name"
           className="rounded-xl"
        />
        {formik.touched.name && formik.errors.name ? (
          <div className="text-red-500 italic">{formik.errors.name}</div>
        ) : null}

        <label htmlFor="email">Email</label>
        <input
          type="email"
          id="email"
          name="email"
          value={formik.values.email}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          placeholder="Email"
           className="rounded-xl"
        />
        {formik.touched.email && formik.errors.email ? (
          <div className="text-red-500 italic">{formik.errors.email}</div>
        ) : null}

        <label htmlFor="location">Location</label>
        <input
          type="text"
          id="location"
          name="location"
          value={formik.values.location}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          placeholder="Location"
           className="rounded-xl"
        />
        {formik.touched.location && formik.errors.location ? (
          <div className="text-red-500 italic">{formik.errors.location}</div>
        ) : null}
        

        <label htmlFor="image_url">Image URL</label>
        <input
          type="text"
          id="image_url"
          name="image_url"
          value={formik.values.image_url}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          placeholder="Image URL"
           className="rounded-xl"
        />
        {formik.touched.image_url && formik.errors.image_url ? (
          <div className="text-red-500 italic">{formik.errors.image_url}</div>
        ) : null}
    
        <button type="submit" disabled={formik.isSubmitting || !formik.isValid} className="bg-blue-500 rounded-lg disabled:opacity-50 ml-4">{transporterToEdit ? "Update Transporter" : "Add Transporter"}</button>
      </form>
      </div>
    )
}